// In-memory client state (Jotai). Persistence is owned by the repository layer
// (`lib/repo.ts`) — cloud (Firestore/GCS via the function) or local (localStorage).

import { atom } from 'jotai';
import type { BankEntry } from './repo';
import type { NewsAtom, Source, StoryEvent, Topic } from './types';

export const topicsAtom = atom<Topic[]>([]);
export const sourcesAtom = atom<Source[]>([]);
export const atomsAtom = atom<NewsAtom[]>([]);
export const eventsAtom = atom<StoryEvent[]>([]);
export const eventBankAtom = atom<BankEntry[]>([]);
